import { Avatar, Button, Card, Col, Input, Modal, Row, Tag, Tooltip } from 'antd'
import _ from 'lodash'
import React from 'react'
import { config } from 'xadmin'
import { Icon } from 'xadmin-ui'
import { ModelSelectMultip } from '../../../components/ModelSelect'
import SortList from './SortList'

// parse JSON
const parse = (value) => {
  if (value) {
    return value
  } else {
    return { parent: [], child: [] }
  }
}

class Relation extends React.Component {

  state = {
    visible: false,
    type: null,
    filter: [],
    models: null,
    description: null
  }

  changeValueForInput = (parent, child) => {
    const { onChange } = this.props
    const value = { parent, child }
    onChange(value)
  }

  showModal = (k) => {
    const { value, option } = this.props
    const { parent, child } = parse(value)
    if (!option) {
      this.setState({
        type: k,
        visible: true,
        filter: [...parent, ...child]
      })
    } else {
      const form = option && option.form
      const formState = form && form.getState()
      const self = formState && formState.values ? { id: formState.values.id, name: formState.values.name } : null
      this.setState({
        type: k,
        visible: true,
        filter: [...parent, ...child, self]
      })
    }
  }

  handleCancel = (e) => {
    this.setState({ visible: false })
  }

  sortParent = (orderParent) => {
    const { value } = this.props
    const { child } = parse(value)
    this.changeValueForInput(orderParent, child)
  }

  sortchild = (orderchild) => {
    const { value } = this.props
    const { parent } = parse(value)
    this.changeValueForInput(parent, orderchild)
  }

  addItem = (model, description) => {
    const { type } = this.state
    const { value } = this.props
    const { parent, child } = parse(value)
    if (model) {
      if (type == 'p') {
        this.changeValueForInput([...parent, ...model], child)
      } else {
        this.changeValueForInput(parent, [...child, ...model])
      }
    }
  }

  deleteItem = (name, type) => {
    const { value } = this.props
    const { parent, child } = parse(value)
    if (type == 'p') {
      this.changeValueForInput([..._.remove(parent, n => n.name != name)], child)
    } else {
      this.changeValueForInput(parent, [..._.remove(child, n => n.name != name)])
    }
  }

  editType = (name, value, type) => {
    const { value: v } = this.props
    const { parent, child } = parse(v)
    if (type == 'p') {
      const newValue = parent.map(item => {
        if (item.name == name) return { ...item, type: value }
        return item
      })
      this.changeValueForInput(newValue, child)
    } else {
      const newValue = child.map(item => {
        if (item.name == name) return { ...item, type: value }
        return item
      })
      this.changeValueForInput(parent, newValue)
    }
  }

  onChange = (data) => this.setState(data)

  handleOk = () => {
    const { models, description } = this.state
    this.addItem(models, description)
    this.handleCancel()
    this.setState({ models: null, description: null })
  }
  render() {
    const { value } = this.props
    const { filter, type, models } = this.state
    const { parent, child } = parse(value)
    const parentTitle = <div><Icon type="rise" style={{ marginRight: 10 }} />父级关系</div>
    const childTitle = <div><Icon type="fall" style={{ marginRight: 10 }} />子级关系</div>
    // console.log(value)
    return (
      <Row>
        <Col span={12}>
          <Panel
            onClick={this.showModal}
            title={parentTitle}
            data={parent}
            dataType={'p'}
            deleteItem={this.deleteItem}
            editType={this.editType}
            editSchemaForm={this.sortParent} />
        </Col>
        <Col span={12}>
          <Panel
            onClick={this.showModal}
            title={childTitle}
            data={child}
            deleteItem={this.deleteItem}
            dataType={'c'}
            editType={this.editType}
            editSchemaForm={this.sortchild} />
        </Col>
        <Modal
          width={400}
          okText="确定"
          title="模型列表"
          cancelText="取消"
          onOk={this.handleOk}
          destroyOnClose={true}
          visible={this.state.visible}
          onCancel={this.handleCancel}
          okButtonProps={{ disabled: !(models && !_.isEmpty(models)) }}
        >
          <ModelsList
            filter={filter}
            models={this.state.models}
            onChange={this.onChange}
            handleCancel={this.handleCancel}
            description={this.state.description}
            data={value[type && type == 'p' ? 'parent' : 'child']}
          />
        </Modal>
      </Row>
    )
  }
}
class ModelsList extends React.Component {

  getSeletModel = (models) => {
    this.props.onChange({ models })
  }
  onChange = (e) => {
    this.props.onChange({ description: e.target.value })
  }

  render() {
    const style = { lineHeight: '32px', fontSize: 14, fontWeight: 700 }
    const { filter, models, description } = this.props
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={4} offset={2} style={style}> 模型</Col>
          <Col span={18}>
            <ModelSelectMultip
              filter={filter} width={236}
              input={{ onChange: this.getSeletModel, value: models }}
            />
          </Col>
        </Row>
        {/* <Row style={{ marginBottom: 20 }}>
          <Col span={4} offset={2} style={style}>关系</Col>
          <Col span={18}>
            <Input style={{ width: 236 }}
              value={description}
              onChange={this.onChange}
              placeholder="关系描述..." />
          </Col>
        </Row > */}
      </div>
    )
  }
}

const Panel = (props) => {
  const { data, title, onClick, editSchemaForm, editType, dataType, deleteItem } = props
  const moveCard = (dragIndex, hoverIndex) => {
    if (dragIndex != undefined && hoverIndex != undefined) {
      const refresh = data.map(item => item)
      refresh[dragIndex] = data[hoverIndex]
      refresh[hoverIndex] = data[dragIndex]
      editSchemaForm(_.compact(refresh))
    }
  }


  const AvatarIcon = (props) => {
    if (props.icon) {
      return <Avatar size={18} shape="square" src={config('mediaUrl') + props.icon} style={{ margin: '0 15px 3px 0' }} />
    } else {
      return <Avatar size={18} shape="square" style={{ margin: '0 15px 3px 0' }}>M</Avatar>
    }
  }
  return (
    <Card
      size="small"
      className="relation-panel"
      title={title}
      extra={<Button onClick={() => onClick(dataType)} size="small" shape="circle" icon={<Icon type="plus" />} />}
      style={{ width: 260, padding: 2 }}
    >
      {data && data.length > 0 ? data.map((item, i) => {
        return (
          <SortList
            key={item.name}
            index={i}
            id={item.name}
            moveCard={moveCard}>
            <PanelItem
              icon={<AvatarIcon icon={item.icon} />}
              name={item.name}
              value={item.type}
              deleteItem={deleteItem}
              editType={editType}
              dataType={dataType} />
          </SortList>
        )
      }) : null}
    </Card>
  )
}

class PanelItem extends React.Component {
  state = {
    inputVisible: false,
  }

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus())
  }

  handleInputChange = (e) => {
    const { name, editType, dataType } = this.props
    editType(name, e.target.value, dataType)
  }

  handleInputConfirm = () => {
    this.setState({ inputVisible: false })
  }

  saveInputRef = input => this.input = input

  render() {
    const { inputVisible } = this.state
    const { name, value, icon, dataType, deleteItem } = this.props
    const sliceLen = 4
    const isLong = value && value.length > sliceLen
    const nameLen = name.length

    return (
      <div>
        <Row>
          <Col span={2}><div style={{ marginRight: 5 }}>{icon} </div></Col>
          <Col span={10}>
            <span style={{ marginLeft: 4 }}>
              {nameLen <= 6 ? name :
                <Tooltip title={name} key={name}>
                  {`   ${name && name.slice(0, 5)}...`}
                </Tooltip>}
            </span>
          </Col>
          <Col span={6}>
            {inputVisible && (
              <Input
                ref={this.saveInputRef}
                type="text"
                size="small"
                style={{ width: 78 }}
                value={value}
                onChange={this.handleInputChange}
                onBlur={this.handleInputConfirm}
              />
            )}
            {!inputVisible && (
              !isLong ? <Tooltip title="双击可编辑关系描述！"><Tag
                onClick={this.showInput}
                style={{ borderStyle: 'dashed', cursor: 'pointer' }}
              >
                {value}
              </Tag></Tooltip> : <Tooltip title={value} key={value}>
                <Tag
                  onClick={this.showInput}
                  style={{ borderStyle: 'dashed' }}
                >
                  {`${value && value.slice(0, sliceLen)}...`}
                </Tag>
              </Tooltip>
            )}
          </Col>
          <Col span={4} offset={2}>
            <Icon type="drag" style={{ marginRight: 5 }} />
            <Icon
              style={{ cursor: 'pointer' }}
              type="delete"
              onClick={() => { deleteItem(name, dataType) }} />
          </Col>
        </Row>
      </div>
    )
  }
}

class RelationWrap extends React.Component {

  render() {
    const { input: { name, value, onChange }, label, meta, field, option } = this.props
    return <Relation onChange={onChange} value={value} option={option} />
  }
}

export default RelationWrap
